module.exports = __webpack_public_path__ + "img/product1_3.d69fd321.png";